module.exports = __webpack_public_path__ + "img/bubble-happy.704864ef.svg";